import React from 'react';
import styles from './Button.module.css';

const clsx = (...args) => args.filter(Boolean).join(' ');

const Button = React.forwardRef(function Button(
  {
    children,
    variant = 'primary',
    size = 'md',
    tone = 'light',
    fullWidth = false,
    loading = false,
    disabled = false,
    type = 'button',
    leadingIcon,
    trailingIcon,
    className,
    ...rest
  },
  ref
) {
  const isOnDark = tone === 'dark';
  const cls = clsx(
    styles.btn,
    styles[variant],
    styles[size],
    isOnDark && styles.onDark,
    fullWidth && styles.fullWidth,
    className
  );

  return (
    <button
      ref={ref}
      type={type}
      className={cls}
      disabled={disabled || loading}
      aria-busy={loading || undefined}
      {...rest}
    >
      {loading ? (
        <span className={styles.spinner} aria-hidden="true" />
      ) : (
        leadingIcon
      )}
      {children}
      {!loading && trailingIcon}
    </button>
  );
});

export default Button;
